import PropTypes from 'prop-types';

export const DisplayInformationPropType = PropTypes.shape({
  name: PropTypes.string,
  displayName: PropTypes.string,
  colorSvg: PropTypes.string,
  iconColor: PropTypes.string,
});

/**
 * @typedef {object} DisplayInformationPropType
 * @property {string} name
 * @property {string} displayName
 * @property {string} colorSvg
 * @property {string} iconColor
 */
